import { Box, Container, Flex, Image } from '@chakra-ui/react';
import logo from '@/assets/icon/logo.svg';
import loginBanner from '@/assets/image/login-banner.svg';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/store/auth';
import { SignUpStep, useSignUp } from '@/store/signup';
import CreateAccount from './CreateAccount';
import EmailVerification from './EmailVerification';

export default function SignUp() {
  const { isLoggedIn } = useAuth();
  const signUpStore = useSignUp();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/');
    }
  }, [isLoggedIn, navigate]);

  return (
    <Container
      maxW="100%"
      minH="100vh"
      w="100%"
      h="100vh"
      p={0}
      bg="background.primary"
      display="flex"
      flexDir="column"
      overflow="hidden"
    >
      <Flex flexGrow={1} w="100%" h="100%" justifyContent="center" alignItems="center">
        <Box w="50%" h="100%" pb="100px" bg="background.primary">
          <Flex p="32px 50px" zIndex={1000}>
            <Image
              src={logo}
              alt="logo"
              width="145px"
              onClick={() => navigate('/')}
              cursor="pointer"
            />
          </Flex>

          {signUpStore.step === SignUpStep.CreateAccount && <CreateAccount />}
          {signUpStore.step === SignUpStep.EmailVerification && <EmailVerification />}
        </Box>
        <Box w="50%" display="flex" justifyContent="center" alignItems="center" bg="#DBE4FF">
          <Image src={loginBanner} alt="Sign Up Illustration" maxW="100%" maxH="100%" />
        </Box>
      </Flex>
    </Container>
  );
}
